/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Connection, ConnectionType } from '../../../redux/slices/connectionsSlice';
import Button from '../buttons/Button';
import localContactService from '../../../services/localContactService';
import HoverButton from '../buttons/HoverButton';
import { PendingBadge, UnverifiedBadge, VerifiedBadge } from '../icons/ConnectionTypeBadge';

interface ConnectionStatusProps {
  connection: Connection;
  interactive?: boolean;
  className?: string;
}

export default function ConnectionStatus({
  connection,
  interactive = false,
  className = '',
}: ConnectionStatusProps): JSX.Element {
  if (connection.type === ConnectionType.PERSONAL_MOMENT_CONNECTION)
    return <VerifiedStatus className={className} />;
  if (connection.type === ConnectionType.B2C_CONNECTION)
    return <VerifiedStatus className={className} />;
  if (connection.type === ConnectionType.LOCAL_CONTACT && connection.inviteSent)
    return <PendingStatus className={className} />;
  return (
    <UnverifiedStatus connection={connection} interactive={interactive} className={className} />
  );
}

interface StatusProps {
  className: string;
}

function VerifiedStatus({ className }: StatusProps) {
  return <VerifiedBadge className={className} />;
}

function PendingStatus({ className }: StatusProps) {
  return <PendingBadge className={className} />;
}

type UnverifiedStatusProps = StatusProps & {
  connection: Connection;
  interactive: boolean;
};

function UnverifiedStatus({ connection, interactive, className }: UnverifiedStatusProps) {
  return <UnverifiedBadge className={className} />;
}
